module.exports = __webpack_public_path__ + "img/nl.1376e4c7.svg";